import { ResourceDetail, ResourceRequestBody } from '../types/resource.types';
import { inject, Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class ResourceApiService {
  private http = inject(HttpClient);
  private base = 'resource';

  /** include: enrichment keys to attach, e.g. ['content', 'tags', 'favorited'] */
  getResource(id: number, include: string[] = []): Observable<ResourceDetail> {
    const params = include.length
      ? new HttpParams().set('include', include.join(','))
      : new HttpParams();
    return this.http.get<ResourceDetail>(`${this.base}/${id}`, { params });
  }

  createResource(value: ResourceRequestBody): Observable<ResourceDetail> {
    return this.http.post<ResourceDetail>(this.base, value);
  }

  updateResource(id: number, value: ResourceRequestBody): Observable<ResourceDetail> {
    return this.http.put<ResourceDetail>(`${this.base}/${id}`, value);
  }

  addResourceTag(id: number, tagId: number) {
    return this.http.put<void>(`${this.base}/${id}/tag/${tagId}`, null);
  }
  removeResourceTag(id: number, tagId: number) {
    return this.http.delete<void>(`${this.base}/${id}/tag/${tagId}`);
  }
}
